function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7809 6.54698C21.7809 6.54698 21.566 5.03019 20.9043 4.36417C20.0664 3.48761 19.1297 3.48331 18.7 3.43175C15.6234 3.20831 11.0043 3.20831 11.0043 3.20831H10.9957C10.9957 3.20831 6.37656 3.20831 3.3 3.43175C2.87031 3.48331 1.93359 3.48761 1.0957 4.36417C0.433984 5.03019 0.223438 6.54698 0.223438 6.54698C0.223438 6.54698 0 8.33019 0 10.1091V11.7763C0 13.5552 0.219141 15.3384 0.219141 15.3384C0.219141 15.3384 0.433984 16.8552 1.09141 17.5212C1.9293 18.3978 3.0293 18.3677 3.51914 18.4622C5.28086 18.6298 11 18.6814 11 18.6814C11 18.6814 15.6234 18.6728 18.7 18.4536C19.1297 18.4021 20.0664 18.3978 20.9043 17.5212C21.566 16.8552 21.7809 15.3384 21.7809 15.3384C21.7809 15.3384 22 13.5595 22 11.7763V10.1091C22 8.33019 21.7809 6.54698 21.7809 6.54698ZM8.72695 13.8001V7.61691L14.6695 10.7192L8.72695 13.8001Z",
  fill: "currentColor"
});
function SvgYouTubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeIcon);
export default __webpack_public_path__ + "static/media/YouTube Icon.9b504d3983c405a0a65ad9778a37de8a.svg";
export { ForwardRef as ReactComponent };